import React from "react";
import Help from "../Help/Help";
import Users from "../Users/Users";
import Logout from "./Logout";

export default function ManagerHeader() {
  return (
    <div className="m-system-panel">
      <p className="m-system-panel-title">Tamima panel</p>
      <div className="m-system-panel-tools">
        <Help />
        <Users />
        <Logout />
      </div>
    </div>
  );
}
